import { useCallback } from 'react';
import { useRemoveCalendarSyncMutation } from 'shared/hooks/queries/use-remove-calendar-sync-mutation';
import { RemoveCalendarSyncInput } from 'shared/services/backend-api';

export const useRemoveCalendarSync = () => {
  const { mutate } = useRemoveCalendarSyncMutation();

  return useCallback(
    (input: RemoveCalendarSyncInput) => mutate(input),
    [mutate],
  );
};
